(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["de-country-recommendation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('de-country-recommendation')) {
    customElements.define('de-country-recommendation', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.editor = this.dataset.editor === 'true' || Boolean(window.Shopify?.designMode);
        this.suppressed = false;
        this.sites = {
          DE: { name: 'Germany', url: 'https://depow.de/' },
          AU: { name: 'Australia', url: 'https://depow.com.au/' },
          GB: { name: 'the United Kingdom', label: 'United Kingdom', url: 'https://depow.co.uk/' },
          FR: { name: 'France', url: 'https://depow.fr/' },
          ES: { name: 'Spain', url: 'https://depow.es/' },
          IT: { name: 'Italy', url: 'https://www.depow.it/' }
        };
        const options = { signal: this.controller.signal };
        this.querySelector('[data-de-country-close]').addEventListener('click', () => this.dismiss(false), options);
        this.querySelector('[data-de-country-stay]').addEventListener('click', () => this.dismiss(true), options);
        this.querySelector('[data-de-country-visit]').addEventListener('click', () => {
          if (!this.editor) this.saveSessionDismissal();
        }, options);
        document.addEventListener('click', (event) => {
          if (event.target.closest('[data-de-world-current], [data-de-region-current]')) this.dismiss(true);
          else if (event.target.closest('[data-de-world-destination], [data-de-region-destination]')) this.dismiss(false);
        }, options);

        if (this.editor) {
          this.querySelector('[data-de-country-editor]').hidden = false;
          this.show('DE');
          return;
        }
        if (!['depow.com', 'www.depow.com'].includes(window.location.hostname)) return;
        if (this.wasDismissed()) return;
        this.detect();
      }

      disconnectedCallback() {
        clearTimeout(this.timeout);
        this.controller?.abort();
        this.controller = null;
      }

      wasDismissed() {
        try {
          if (sessionStorage.getItem('de_country_banner_closed_v1') === '1') return true;
        } catch {}
        try {
          const expiry = Number(localStorage.getItem('de_country_global_until_v1'));
          if (Number.isFinite(expiry) && expiry > Date.now()) return true;
        } catch {}
        return false;
      }

      saveSessionDismissal() {
        try { sessionStorage.setItem('de_country_banner_closed_v1', '1'); } catch {}
      }

      dismiss(rememberGlobal) {
        this.suppressed = true;
        this.hidden = true;
        if (this.editor) return;
        this.saveSessionDismissal();
        if (rememberGlobal) {
          try { localStorage.setItem('de_country_global_until_v1', String(Date.now() + 30 * 24 * 60 * 60 * 1000)); } catch {}
        }
      }

      async detect() {
        this.timeout = setTimeout(() => this.controller?.abort(), 3000);
        try {
          const response = await fetch('https://de-country-detect.yucongtwo.workers.dev/', {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit',
            cache: 'no-store',
            referrerPolicy: 'no-referrer',
            signal: this.controller.signal
          });
          if (!response.ok) return;
          const data = await response.json();
          if (!this.isConnected || this.suppressed || this.wasDismissed()) return;
          if (!Object.hasOwn(this.sites, data.country)) return;
          if (data.website !== this.sites[data.country].url) return;
          this.show(data.country);
        } catch {
          this.hidden = true;
        } finally {
          clearTimeout(this.timeout);
        }
      }

      show(country) {
        const site = this.sites[country];
        if (!site) return;
        this.querySelector('[data-de-country-message]').textContent = `Shopping from ${site.name}? Visit our local website.`;
        const link = this.querySelector('[data-de-country-visit]');
        link.textContent = `Visit ${site.label || site.name} →`;
        link.href = site.url;
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["de-region-switcher-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('de-world-selector')) {
  customElements.define('de-world-selector', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.prepareTriggers();

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-de-world-open]');
        if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(trigger, event);
      }, options);

      document.addEventListener('keydown', (event) => {
        const trigger = event.target.closest('[data-de-world-open]');
        if (trigger && event.key === ' ') {
          event.preventDefault();
          this.open(trigger, event);
        }
      }, options);

      document.addEventListener('shopify:section:load', () => this.prepareTriggers(), options);
      this.dialog.addEventListener('pointerdown', (event) => {
        this.backdropPress = this.isBackdrop(event);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-de-world-close], [data-de-world-current]')) {
          event.preventDefault();
          this.close();
        } else if (this.backdropPress && this.isBackdrop(event)) {
          this.close();
        }
        this.backdropPress = false;
      }, options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const elements = [...this.dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]')]
          .filter((element) => element.getClientRects().length > 0);
        const first = elements[0];
        const last = elements[elements.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.restore();
      }, options);
      window.addEventListener('pagehide', () => {
        if (this.dialog.open) this.dialog.close();
        this.restore();
      }, options);
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restore();
      this.controller?.abort();
    }

    prepareTriggers() {
      document.querySelectorAll('[data-de-world-open]').forEach((trigger) => {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', this.dialog.id);
        trigger.setAttribute('aria-expanded', String(this.dialog.open));
      });
    }

    isBackdrop(event) {
      if (event.target !== this.dialog) return false;
      const box = this.dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    }

    open(trigger, event) {
      if (this.dialog.open) return;

      const drawer = document.querySelector('header-drawer');
      if (drawer?.querySelector('details[open]') && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(event, trigger);
        drawer.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }

      this.opener = trigger;
      this.scrollPosition = { x: window.scrollX, y: window.scrollY };
      this.savedStyles = ['position', 'top', 'left', 'width', 'padding-right'].map((name) => [
        name, document.body.style.getPropertyValue(name), document.body.style.getPropertyPriority(name)
      ]);
      this.savedOverflow = [document.documentElement.style.overflow, document.documentElement.style.getPropertyPriority('overflow')];
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition.y}px`;
      document.body.style.left = `-${this.scrollPosition.x}px`;
      document.body.style.width = '100%';
      if (scrollbar > 0) document.body.style.paddingRight = `${padding + scrollbar}px`;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;

      try {
        this.dialog.showModal();
        this.prepareTriggers();
        this.dialog.querySelector('[data-de-world-close]').focus({ preventScroll: true });
      } catch (error) {
        this.restore();
        throw error;
      }
    }

    close() {
      if (this.dialog?.open) this.dialog.close();
      this.restore();
    }

    restore() {
      if (!this.locked) return;
      this.locked = false;
      this.savedStyles.forEach(([name, value, priority]) => {
        if (value) document.body.style.setProperty(name, value, priority);
        else document.body.style.removeProperty(name);
      });
      if (this.savedOverflow[0]) document.documentElement.style.setProperty('overflow', ...this.savedOverflow);
      else document.documentElement.style.removeProperty('overflow');
      window.scrollTo({ left: this.scrollPosition.x, top: this.scrollPosition.y, behavior: 'instant' });
      this.prepareTriggers();
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
